import { useCallback, useState } from "react";
import { use1Second } from "./use1Second";
import Sound from '../audio/Start-bell.wav';
import Bell from '../audio/EndBell.m4a';

const startBell = new Audio(Sound);
const endBell = new Audio(Bell);





export const useTimer = ({
  seconds: initialSeconds = 1500,
  running: initiallyRunning = false
} = {}) => {
  const [seconds, setSeconds] = useState(initialSeconds);
  const [running, setRunning] = useState(initiallyRunning);

    

  const tick = useCallback(
    () => (running ? setSeconds((seconds) => seconds - 1) : undefined),
    [running]
  );
     function start() { 
         startBell.play()
      setRunning(true);
      
  }
  const pause = () => { 
      startBell.play()
      setRunning(false);
  }
  const reset = () => setSeconds(1500);

  const stop = () => {
      endBell.play()
    pause();
    reset();
  };

 
  

  use1Second(tick);

  return {

      pause, seconds, running, start, setSeconds, stop, initialSeconds

  }

//   return (
//       <div>
//           <Clock pause={pause} seconds={seconds} running={running} start={start} stop={stop}></Clock>
//       </div>
//   );
};

